<h3>What is the Nutri-Score?</h3>
<p>
  The Nutri-Score is a logo that informs you about the nutritional quality of a product or a recipe, by positioning it on a 5-level scale associating letters
  with colors.
</p>

<div class="nutriscore">
  <div class="nutriscore-picto">
    <ion-icon src="/assets/svg/dish/nutriscore/nutriscore-A.svg"></ion-icon>
  </div>
  <div class="nutriscore-label">A for the most nutritionally favorable recipes</div>
</div>
<div class="nutriscore">
  <div class="nutriscore-picto">
    <ion-icon src="/assets/svg/dish/nutriscore/nutriscore-E.svg"></ion-icon>
  </div>
  <div class="nutriscore-picto">E for the least nutritionally favorable recipes</div>
</div>

<h3>How is the Nutri-Score calculated ?</h3>
<p>The Nutri-Score calculation was developed by scientists, physicians and nutritionists. It takes into account, for 100g of food, the content:</p>
<ul>
  <li>- In nutrients and foods to promote: fibers, proteins, fruits and vegetables, legumes, nuts and vegetable oils (olive , rapeseed and nuts),</li>
  <li>- In terms of energy and nutrients to be limited: calories, saturated fatty acids, sugars, salt.</li>
</ul>
<h3>What is the purpose of Nutri-Score ?</h3>
<ul>
  <li>- Thanks to its simplicity and intuitive nature, offer real transparency on the overall quality of our recipes,</li>
  <li>- Improve our recipes (less salt, fat, sugar, more fiber…),</li>
  <li>- Make it easier to choose foods of better nutritional quality,</li>
  <li>- Improve the understanding of the nutritional quality of proposed offer.</li>
</ul>
<h3>And concretely, what does that change for you?</h3>
<p>
  The Nutri-Score makes it easy to compare the nutritional quality of products or recipes in the same category . The objective is to balance your platter over
  the week by favoring dishes rated A or B without excluding dishes rated D or E.
</p>
<footer>
  <p>THE CHOICE OF EAT WELL EVERYDAY!</p>
  <p>A varied and balanced diet helps to stay healthy.</p>
</footer>
